"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapBackendColorToTheme = void 0;
var _getColorAndShadeKeys = require("./getColorAndShadeKeys");
var _isCorrectColor = require("./isCorrectColor");
var _isCorrectShade = require("./isCorrectShade");
var _isOldColor = require("./isOldColor");
var _mapOldColor = require("./mapOldColor");
/**
 * Maps backend color to color from `theme.pallette` object.
 * @returns Color as `hex string` or `fallBackColor` if color is not found in `theme.pallette`.
 */
const mapBackendColorToTheme = ({
  backendColor,
  fallBackColor = '#ffffff',
  theme: {
    palette
  }
}) => {
  if (!backendColor) {
    return fallBackColor;
  }

  // Check for old colors White, Black, DarkGrey, Brown, Green
  if ((0, _isOldColor.isOldColor)(backendColor)) {
    return (0, _mapOldColor.mapOldColor)(backendColor, palette);
  }
  const {
    color,
    shade
  } = (0, _getColorAndShadeKeys.getColorAndShadeKeys)({
    backendColor,
    palette
  }) ?? {};
  if (!color || !shade || !(0, _isCorrectColor.isCorrectColor)(palette, color)) {
    return fallBackColor;
  }
  const paletteColor = palette[color];
  if (typeof paletteColor !== 'object' || !(0, _isCorrectShade.isCorrectShade)(paletteColor, shade)) {
    return fallBackColor;
  }
  return paletteColor[shade];
};
exports.mapBackendColorToTheme = mapBackendColorToTheme;
//# sourceMappingURL=mapBackendColorToTheme.js.map